//#region Imports
/**
To use React related functionality
*/
import React from 'react';
/**
To show and use Trip Warning component
*/
import TripWarning from './TripWarning';
/**
To use Icon.
*/
import {IconAlert} from '../../Icons';
//#endregion

/**
* It is written in Diretion>>TripWarnings>>DifferentDayWarning.
* Warns the user if the trip plan is for a different day than the one intended. This feature is useful when the user has planned a trip for a specific day but accidentally forgets to change the date when searching for the trip on another day.
* Function is used in Directions>>TripWarning.
* @param {Object} Props
* @return {HTMLElement} Warning Body
*/
const DifferentDayWarning = props => {
    return (
        <TripWarning
            icon={<IconAlert />}
            screenReaderText='Alert: Trip leaves on a different day than your request.'
            summaryText='Some of your trips leave on a different day than your request.'
            {...props}
        />
    );
};

export default DifferentDayWarning;